export const providerEnum = [
  { id: 1, name: "University" },
  { id: 2, name: "Affiliate Partner" },
  { id: 3, name: "Partner Agent" },
  { id: 4, name: "Sub Agent" },
];
